export default "__VITE_ASSET__CAo32hM3__"